<ul class="nav nav-tabs justify-content-center d-none d-md-flex">
  <li class="nav-item">
    <a
      class="nav-link"
      title="Reports Dashboard"
      href="javascript:void(0)"
      [routerLink]="'/reporting'"
      routerLinkActive="active"
      [routerLinkActiveOptions]="{ exact: true }"
      ariaCurrentWhenActive="page"
      aria-current="page"
      >Dashboard</a
    >
  </li>
  <li class="nav-item">
    <a
      class="nav-link"
      title="Support Insights"
      href="javascript:void(0)"
      [routerLink]="'/reporting/support-insights'"
      routerLinkActive="active"
      [routerLinkActiveOptions]="{ exact: true }"
      ariaCurrentWhenActive="page"
      aria-current="page"
      >Support Insights</a
    >
  </li>
  <li *ngIf="evidenceReportEnabled" class="nav-item">
    <a
      class="nav-link"
      title="Evidence"
      href="javascript:void(0)"
      [routerLink]="'/reporting/evidence'"
      routerLinkActive="active"
      [routerLinkActiveOptions]="{ exact: true }"
      ariaCurrentWhenActive="page"
      aria-current="page"
      >Evidence</a
    >
  </li>
  <li class="nav-item">
    <a
      class="nav-link"
      title="Growth"
      href="javascript:void(0)"
      [routerLink]="'/reporting/badge-progress'"
      routerLinkActive="active"
      [routerLinkActiveOptions]="{ exact: true }"
      ariaCurrentWhenActive="page"
      aria-current="page"
      >Growth</a
    >
  </li>
  <li class="nav-item">
    <a
      class="nav-link"
      title="Observation Report"
      href="javascript:void(0)"
      [routerLink]="'/reporting/observations'"
      routerLinkActive="active"
      [routerLinkActiveOptions]="{ exact: true }"
      ariaCurrentWhenActive="page"
      aria-current="page"
      >Observation</a
    >
  </li>
  <li class="nav-item" *ngIf="proformReportEnabled">
    <a
      class="nav-link"
      title="ProForms"
      href="javascript:void(0)"
      [routerLink]="'/reporting/proforms'"
      routerLinkActive="active"
      [routerLinkActiveOptions]="{ exact: true }"
      ariaCurrentWhenActive="page"
      aria-current="page"
      >ProForms</a
    >
  </li>
  <ng-container *ngIf="PDReportsEnabled">
    <li class="nav-item">
      <a
        class="nav-link"
        title="Staff Member Credits Earned"
        href="javascript:void(0)"
        [routerLink]="'/reporting/credits-earned'"
        routerLinkActive="active"
        [routerLinkActiveOptions]="{ exact: true }"
        ariaCurrentWhenActive="page"
        aria-current="page"
        >Credits</a
      >
    </li>
    <li class="nav-item">
      <a
        class="nav-link"
        title="Learning & Events"
        href="javascript:void(0)"
        [routerLink]="'/reporting/pd-session-summary'"
        routerLinkActive="active"
        [routerLinkActiveOptions]="{ exact: true }"
        ariaCurrentWhenActive="page"
        aria-current="page"
        >Learning & Events</a
      >
    </li>
  </ng-container>
  <li class="nav-item">
    <a
      class="nav-link"
      title="Session Details"
      href="javascript:void(0)"
      [routerLink]="'/reporting/session-details'"
      routerLinkActive="active"
      [routerLinkActiveOptions]="{ exact: true }"
      ariaCurrentWhenActive="page"
      aria-current="page"
      >Session Details</a
    >
  </li>
</ul>

<!-- MOBILE NAV -->
<div
  class="custom-select d-md-none"
  [class.open]="customCollapsed"
  (click)="toggleCustomCollapsed()">
  <div class="custom-select__trigger">
    <div>{{ selectedPath }}</div>
    <i *ngIf="!customCollapsed" class="bi bi-caret-up-fill"></i>
    <i *ngIf="customCollapsed" class="bi bi-caret-down-fill"></i>
  </div>
  <ul class="custom-options">
    <li
      [routerLink]="'/reporting'"
      routerLinkActive="active"
      [routerLinkActiveOptions]="{ exact: true }"
      class="custom-option">
      Dashboard
    </li>
    <li
      [routerLink]="'/reporting/support-insights'"
      routerLinkActive="active"
      [routerLinkActiveOptions]="{ exact: true }"
      class="custom-option">
      Support Insights
    </li>
    <li
      *ngIf="evidenceReportEnabled"
      [routerLink]="'/reporting/evidence'"
      routerLinkActive="active"
      [routerLinkActiveOptions]="{ exact: true }"
      class="custom-option">
      Evidence
    </li>
    <li
      [routerLink]="'/reporting/badge-progress'"
      routerLinkActive="active"
      [routerLinkActiveOptions]="{ exact: true }"
      class="custom-option">
      Growth
    </li>
    <li
      [routerLink]="'/reporting/observations'"
      routerLinkActive="active"
      [routerLinkActiveOptions]="{ exact: true }"
      class="custom-option">
      Observation
    </li>
    <li
      *ngIf="proformReportEnabled"
      [routerLink]="'/reporting/proforms'"
      routerLinkActive="active"
      [routerLinkActiveOptions]="{ exact: true }"
      class="custom-option">
      ProForms
    </li>
    <ng-container *ngIf="PDReportsEnabled">
      <li
        [routerLink]="'/reporting/credits-earned'"
        routerLinkActive="active"
        [routerLinkActiveOptions]="{ exact: true }"
        class="custom-option">
        Credits
      </li>
      <li
        [routerLink]="'/reporting/pd-session-summary'"
        routerLinkActive="active"
        [routerLinkActiveOptions]="{ exact: true }"
        class="custom-option">
        Learning & Events
      </li>
    </ng-container>
    <li
      [routerLink]="'/reporting/session-details'"
      routerLinkActive="active"
      [routerLinkActiveOptions]="{ exact: true }"
      class="custom-option">
      Session Details
    </li>
  </ul>
</div>
